<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const haskoningAuthURL = import.meta.env.VITE_APP_API_BASE_URL + 'oauth/azure/'

const loading = computed(() => store.state.authenticate.loading)
const haskoningLoading = computed(() => store.state.authenticate.haskoningLoading)

const setHaskoningLoading = (payload) => store.dispatch('authenticate/setHaskoningLoading', payload)
</script>

<template>
  <v-card class="px-4 pt-4" flat>
    <v-card-title
      style="
        font-family: 'Roboto', sans-serif;
        font-size: 32px;
        font-weight: 400;
        line-height: 32px;
      "
    >
      Welcome to
    </v-card-title>
    <v-card-title
      style="
        font-family: 'Roboto', sans-serif;
        font-size: 36px;
        font-weight: 500;
        line-height: 36px;
        color: #009eab;
      "
    >
      PACE
    </v-card-title>

    <div class="py-3"></div>
    <v-card-text class="pt-0">
      <a :href="haskoningAuthURL" @click="setHaskoningLoading(true)">
        <v-btn
          color="primary"
          prepend-icon="mdi-login-variant"
          class="text-none"
          :loading="haskoningLoading"
          :disabled="loading"
          elevation="0"
        >
          Haskoning Login
        </v-btn>
      </a>
    </v-card-text>
  </v-card>
</template>
